module.exports = __webpack_public_path__ + "img/901345426.a49ca110.png";